import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { useNavigate } from 'react-router-dom';

export default function Orders({ user }) {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState('all'); // all, month, week
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchOrders() {
      const now = new Date();
      let fromDate;
      if (filter === 'month') {
        fromDate = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
      } else if (filter === 'week') {
        fromDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
      }

      const { data } = await supabase
        .from('orders')
        .select('*')
        .eq('user_id', user.id)
        .order('created_at', { ascending: false })
        
      setOrders(data || []);
    }
    fetchOrders();
  }, [user.id, filter]);

  async function toggleFavorite(order) {
    await supabase.from('orders').update({ favorite: !order.favorite }).eq('id', order.id);
    setOrders(orders.map(o => o.id === order.id ? {...o, favorite: !o.favorite} : o));
  }

  async function handleReorder(order) {
    const { error } = await supabase.from('orders').insert([{ ...order, id: undefined, created_at: new Date().toISOString(), status: 'pending_payment', favorite: false }]);
    if (!error) {
      alert('Order duplicated! You can find it in your orders list.');
      setFilter('all');
    }
  }

  return (
    <div style={{color:'#fff', maxWidth:700, margin:'60px auto', padding:'0 20px'}}>
      <h2 style={{textAlign:'center', marginBottom:24}}>Your Orders</h2>
      <div style={{display:'flex', gap:12, justifyContent:'center', marginBottom:18}}>
        {['all','month','week'].map(key => (
          <button key={key} onClick={()=>setFilter(key)} style={{background:'none',color:'#fff',border:'1px solid #fff',borderRadius:8,padding:'6px 14px',cursor:'pointer',fontWeight:filter===key?700:400}}>
            {key==='all'?'All':key==='month'?'Last Month':'Last Week'}
          </button>
        ))}
      </div>
      {orders.length === 0 && <p style={{textAlign:'center'}}>No orders yet.</p>}
      <ul style={{paddingLeft:0, listStyle:'none'}}>
        {orders.map(order => (
          <li key={order.id} style={{marginBottom:'1em', background:'transparent', borderRadius:8, border: '1px solid #fff', padding:12}}> 
            <div>
              <strong>Status:</strong>{' '}
              {order.status === 'order complete' ? (
                <span style={{color:'#4caf50'}}>Order Complete</span>
              ) : order.status === 'order placed, waiting to be fulfilled' ? (
                <span>Waiting to be fulfilled</span>
              ) : order.status === 'pending_payment' ? (
                <span>Pending Payment</span>
              ) : (
                <span>{order.status}</span>
              )}
            </div>
            {order.total && (
              <div><strong>Total:</strong> ${order.total}</div>
            )}
            <div><strong>Placed:</strong> {new Date(order.created_at).toLocaleString()}</div>
            
            {/* --- Add Group Order Link Display Here --- */}
            {order.group_order_link && (
              <div style={{marginTop:8}}>
                <strong>Track Your Order:</strong>{' '}
                <a 
                  href={order.group_order_link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{color:'#90caf9', textDecoration:'underline'}}
                >
                  View on DoorDash
                </a>
              </div>
            )}

            <div style={{marginTop:8}}>
              <button onClick={()=>toggleFavorite(order)} style={{background:'none',border:'1px solid #fff',color:'#fff',borderRadius:6,padding:'4px 8px',cursor:'pointer',marginRight:8}}>
                {order.favorite ? '★ Favorite' : '☆ Favorite'}
              </button>
              <button 
                onClick={()=>handleReorder(order)} 
                disabled 
                style={{
                  background:'none',
                  border:'1px solid #555',
                  color:'#555',
                  borderRadius:6,
                  padding:'4px 8px',
                  cursor:'not-allowed'
                }}
              >
                Reorder (Coming Soon)
              </button>
            </div>
            {order.status === 'pending_payment' && (
              <button
                onClick={() => navigate(`/payment?order_id=${order.id}`)}
                style={{
                  background:'transparent',
                  color:'#fff',
                  fontWeight:600,
                  border:'1px solid #fff',
                  borderRadius:6,
                  padding:'6px 12px',
                  fontSize:'0.9em',
                  cursor:'pointer',
                  marginTop:8
                }}
              >
                Pay Now
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
